import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import http from './http'
import VueSweetalert2 from "vue-sweetalert2";
import Notifications from 'vue-notification'

import '../src/lib/icons/style.css'

import TokenService from "@/services/token.service";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import 'sweetalert2/dist/sweetalert2.min.css';
// import VueMask from 'v-mask'
import vSelect from "vue-select";
import './utils/filters';
import "vue-select/dist/vue-select.css";
import Multiselect from 'vue-multiselect'

import "./assets/style.css"
import "./assets/core.css"

import 'bootstrap'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/dist/js/bootstrap.bundle'
import 'bootstrap/dist/css/bootstrap.css'
import  '@popperjs/core/dist/umd/popper'



// Vue.use(VueMask);
Vue.use(Notifications)
Vue.use(VueSweetalert2);

Vue.directive('permcheck', {

  inserted: function (el, binding, vnode) {

    if (!JSON.parse(localStorage.getItem('user')).permissions
        .includes(binding.expression.replace(/'/g, "").replace(/"/g, ""))
    ) {
      const wrapper = document.createElement('div')
      wrapper.innerHTML = "<div class='shadow p-3 mb-5 bg-body rounded' style='border: 1px solid red'>" +
          "<p class='p-3 text-center' style='color: #b7323e' >" +
          "You are not authorized to view this resource</p>" +
          "</div>"
      // vnode.elm.parentElement.removeChild(vnode.elm);
      vnode.elm.parentElement.replaceChild(wrapper, vnode.elm);
    }
  },
})

Vue.directive('isadminpermcheck', {

  inserted: function (el, binding, vnode) {

    if (!JSON.parse(localStorage.getItem('user')).permissions
        .includes(binding.expression.replace(/'/g, "").replace(/"/g, ""))
    ) {
      const wrapper = document.createElement('div')
      wrapper.innerHTML = ""
      // vnode.elm.parentElement.removeChild(vnode.elm);
      vnode.elm.parentElement.replaceChild(wrapper, vnode.elm);
    }
  },
})


http.init()

Vue.config.productionTip = false
library.add(fas)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('vue-multiselect', Multiselect)
Vue.component("v-select", vSelect);

if (TokenService.getAccessToken()) {
  http.setHeader();
  http.mountAuthInterceptor();
}

Vue.config.devtools = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
